export function transcriptTextToParagraphs(text: string): string[] {
  const normalized = text.replace(/\r/g, '').trim();
  if (!normalized) return [];

  const blocks = normalized
    .split(/\n\s*\n/)
    .map(block => block.replace(/\s*\n\s*/g, ' ').replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  if (blocks.length > 1) {
    return blocks;
  }

  const sentences = normalized
    .split(/(?<=[.!?])\s+/)
    .map(sentence => sentence.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  const paragraphs: string[] = [];
  let current = '';
  const TARGET = 320;

  sentences.forEach(sentence => {
    if (!current) {
      current = sentence;
      return;
    }
    const candidate = `${current} ${sentence}`;
    if (candidate.length > TARGET) {
      paragraphs.push(current);
      current = sentence;
    } else {
      current = candidate;
    }
  });

  if (current) {
    paragraphs.push(current);
  }

  return paragraphs;
}
